import { FC } from "react";
import { Tabs as AntTabs, TabsProps as AntTabsProps } from "antd";
import { clsx } from "clsx";
import classes from "./Tabs.module.less";

export interface TabsProps extends AntTabsProps {
    /** "pill": the filled bar (default). "line": classic tabs, an ink bar under the active one. */
    variant?: "pill" | "line";
}

export const Tabs: FC<TabsProps> = ({ variant = "pill", className, ...props }) => {
    return <AntTabs {...props} className={clsx(variant === "pill" && classes.tabs, className)} />;
};

Tabs.displayName = "Tabs";
